<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form v-loading="loadingSchedule" @submit.prevent="handleSubmit(onSubmit)">
      <div class="section-header">
        <div class="section-title">Thông tin đăng ký thi</div>
      </div>

      <el-row :gutter="20" class="form-row">
        <el-col :span="12">
          <ValidationProvider v-slot="{ errors }" name="Học viên" rules="required" vid="student">
            <div class="display-flex-column">
              <label>Học viên <span class="required">*</span></label>
              <el-select
                v-model="form.user_id"
                :loading="loadingStudent"
                :remote-method="remoteMethod"
                class="w-100"
                clearable
                filterable
                placeholder="Nhập mã học viên, số điện thoại, tên học viên"
                remote
                reserve-keyword
              >
                <el-option
                  v-for="user in userSearch"
                  :key="user.id"
                  :label="user.id + 100000 + ' - ' + user.name"
                  :value="user.id"
                />
              </el-select>
            </div>
            <div class="fv-plugins-message-container">
              <div class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </el-col>

        <el-col :span="12">
          <ValidationProvider v-slot="{ errors }" name="Ngày thi" rules="required" vid="examDate">
            <div class="display-flex-column">
              <label>Ngày thi <span class="required">*</span></label>
              <el-select
                v-model="form.exam_date"
                class="w-100"
                clearable
                filterable
                placeholder="Chọn ngày thi"
                @change="handleSelectExamDate"
              >
                <el-option
                  v-for="option in dateOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </div>
            <div class="fv-plugins-message-container">
              <div class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="form-row">
        <el-col :span="12">
          <ValidationProvider v-slot="{ errors }" name="Thời gian thi" rules="required" vid="examTime">
            <div class="display-flex-column">
              <label>Thời gian thi <span class="required">*</span></label>
              <el-select
                v-model="form.exam_time"
                :disabled="!form.exam_date || !timeOptions.length"
                class="w-100"
                clearable
                filterable
                placeholder="Chọn khoảng thời gian thi"
              >
                <el-option
                  v-for="option in timeOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </div>
            <div class="fv-plugins-message-container">
              <div class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </el-col>

        <el-col :span="12">
          <ValidationProvider v-slot="{ errors }" name="Kỹ năng thi lại" rules="required" vid="skills">
            <div class="display-flex-column">
              <label>Kỹ năng thi lại <span class="required">*</span></label>
              <el-select
                v-model="form.skills"
                class="w-100"
                clearable
                filterable
                multiple
                placeholder="Chọn kỹ năng thi lại"
              >
                <el-option
                  v-for="option in skillOptions"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
                />
              </el-select>
            </div>
            <div class="fv-plugins-message-container">
              <div class="fv-help-block">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
        </el-col>
      </el-row>

      <div class="form-actions">
        <el-button class="button-cancel" @click="closeDialog">Hủy bỏ</el-button>
        <button
          v-loading="isBusy"
          :disabled="isBusy"
          class="button-confirm"
          type="submit"
        >
          Xác nhận
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import moment from "moment-timezone";
import {SEARCH_CUSTOMER_BY_OR_ID} from "@/core/services/store/user/users.module";
import {
  CREATE_ENTRANCE_RETEST,
  GET_ENTRANCE_RETEST_SCHEDULE,
} from "@/core/services/store/examSchedule/examSchedule";

export default {
  name: "FormEntranceRetest",
  data() {
    return {
      isBusy: false,
      loadingSchedule: false,
      loadingStudent: false,
      searchTimer: null,
      schedules: [],
      dateOptions: [],
      timeOptions: [],
      userSearch: [],
      skillOptions: [
        {id: 4, name: "Speaking"},
        {id: 1, name: "Listening"},
        {id: 2, name: "Reading"},
        {id: 3, name: "Writing"},
      ],
      form: {
        user_id: null,
        exam_date: null,
        exam_time: null,
        skills: [],
      },
    };
  },
  mounted() {
    this.getEntranceExamSchedules();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  methods: {
    remoteMethod(query) {
      clearTimeout(this.searchTimer);
      if (!query) {
        this.userSearch = [];
        this.loadingStudent = false;
        return;
      }

      this.loadingStudent = true;
      this.searchTimer = setTimeout(() => this.getStudents({
        search_customer_by_phoneOrId: query,
        limit: 10000,
        status: 1,
        is_staff: 0,
      }), 300);
    },
    async getStudents(params) {
      try {
        const response = await this.$store.dispatch(SEARCH_CUSTOMER_BY_OR_ID, params);
        this.userSearch = response?.data?.data ?? [];
      } catch (error) {
        this.$message.error(error?.data?.message || "Không thể tìm kiếm học viên");
      } finally {
        this.loadingStudent = false;
      }
    },
    async getEntranceExamSchedules() {
      this.loadingSchedule = true;
      try {
        const response = await this.$store.dispatch(GET_ENTRANCE_RETEST_SCHEDULE);
        if (response?.error) {
          this.$message.error(response.message || "Không thể lấy lịch thi");
          return;
        }

        this.schedules = Array.isArray(response?.data) ? response.data : [];
        this.dateOptions = this.schedules.map(schedule => ({
          value: schedule.exam_date,
          label: this.formatDate(schedule.exam_date),
        }));
      } catch (error) {
        this.$message.error(error?.data?.message || "Không thể lấy lịch thi");
      } finally {
        this.loadingSchedule = false;
      }
    },
    createLocalDate(dateValue, timeValue = "00:00:00") {
      const [year, month, day] = String(dateValue).split("-").map(Number);
      const [hours, minutes, seconds = 0] = String(timeValue).split(":").map(Number);
      return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    isSameDay(left, right) {
      return left.getFullYear() === right.getFullYear()
        && left.getMonth() === right.getMonth()
        && left.getDate() === right.getDate();
    },
    isSelectable(examDate, shift) {
      const registered = Number(shift.registration_count ?? 0);
      const maxSlots = Number(shift.max_slots ?? 0);
      if (!Number.isFinite(registered) || !Number.isFinite(maxSlots) || registered >= maxSlots) {
        return false;
      }

      const selectedDate = this.createLocalDate(examDate);
      const now = new Date();
      if (!this.isSameDay(selectedDate, now)) return true;

      const startTime = this.createLocalDate(examDate, shift.start_time);
      return !Number.isNaN(startTime.getTime())
        && startTime.getTime() > now.getTime()
    },
    handleSelectExamDate() {
      this.form.exam_time = null;
      const schedule = this.schedules.find(item => item.exam_date === this.form.exam_date);
      const shifts = Array.isArray(schedule?.exam_shifts) ? schedule.exam_shifts : [];
      this.timeOptions = shifts
        .filter(shift => this.isSelectable(schedule.exam_date, shift))
        .map(shift => ({
          value: shift.id,
          label: this.formatTime(shift.start_time, shift.end_time),
        }));

      if (this.form.exam_date && !this.timeOptions.length) {
        this.$message.error("Lịch thi trong ngày chọn đã hết. Vui lòng chọn ngày khác.");
      }
    },
    async onSubmit() {
      this.isBusy = true;
      try {
        const response = await this.$store.dispatch(CREATE_ENTRANCE_RETEST, {
          user_id: this.form.user_id,
          marking_exam_shift_id: this.form.exam_time,
          skills: this.form.skills,
        });
        if (response?.error) {
          this.$message.error(response.message || "Đăng ký thi lại thất bại");
          return;
        }

        this.$emit("getListRetest");
        this.$message.success(response?.message || "Đăng ký thi lại thành công");
        this.closeDialog();
      } catch (error) {
        this.$message.error(error?.data?.message || "Đăng ký thi lại thất bại");
      } finally {
        this.isBusy = false;
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    formatDate(value) {
      return value ? moment(value).format("DD-MM-YYYY") : "";
    },
    formatTime(start, end) {
      if (!start || !end) return "";
      return `${String(start).slice(0, 5)} - ${String(end).slice(0, 5)}`;
    },
  },
};
</script>

<style scoped>
.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.section-header {
  margin-bottom: 12px;
}

.section-title {
  color: #111827;
  font-size: 15px;
  font-weight: 600;
}

.form-row {
  margin-bottom: 16px;
}

.required {
  color: red;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 20px;
}

.button-cancel {
  background: #CACACA;
  color: black;
}

.button-confirm {
  padding-right: 15px;
  padding-left: 15px;
  border-radius: 4px;
  background: #5E00B6;
  color: white;
}
</style>
